<!-- Fiko3DYaziIsaretleyiciComponent - Dialog Core içinde render ediliyor -->
<div style="width:100%;min-width:360px;">

    <div *ngIf="isaretleyici">
        <input class="fikoinput" type="text" #inputFikogram placeholder="İsmi" [ngModel]="getYazi() || ''"
            (ngModelChange)="setYazi(inputFikogram.value)">

        <textarea class="fikoinputAciklama" #inputFikogramAciklama placeholder="Açıklaması"
            [ngModel]="isaretleyici?.userData.aciklama"
            (ngModelChange)="isaretleyici.userData.aciklama=inputFikogramAciklama.value;this.FikoYT.degisti.emit();"></textarea>

        <div style="display: flex;align-items:center;">
            <div>
                <input type="color" [ngModel]="getRenk() || '#ffff00'"
                    (ngModelChange)="renkDegisti($event);" style="width: 3em;padding:0px !important;" tabindex="-1">
            </div>
            <div style="flex:1">
                <input type="range" [min]="0.01" [max]="5" tabindex="0" [ngModel]="getBoyut() || 0.3" [step]="0.01"
                    (ngModelChange)="setBoyut($event);"
                    style="margin-top: 0.5rem;flex:1;" />
            </div>
        </div>

        <div class="ui right aligned slider checkbox" id="sabitBoyut_{{ id_dialog }}">
            <input type="checkbox" name="sabitBoyut" [checked]="getSabitBoyut()"
                (change)="setSabitBoyut($any($event.target).checked)">
            <label>Sabit Boyut</label>
        </div>
        <div class="ui right aligned slider checkbox" id="sabitYon_{{ id_dialog }}">
            <input type="checkbox" name="sabitYon" [checked]="getSabitYon()"
                (change)="setSabitYon($any($event.target).checked)">
            <label>Ekrana Paralel</label>
        </div>
    </div>

    <div style="text-align: right; margin-top: 15px;">
        <div class="ui animated mini button" tabindex="0" (click)="kapa()">
            <div class="visible content">Kapat</div>
            <div class="hidden content">
                <i class="check icon"></i>
            </div>
        </div>
    </div>
</div>